/* eslint-disable import/no-cycle */
/* eslint-disable react-hooks/exhaustive-deps */
import { Button } from '@chakra-ui/core';
import React, { FC, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useGetItemProperty } from '../../hooks/useGetItemProperty';
import { FieldOptionT } from '../../types';

interface AddFollowupProps {
  fieldId: string;
  setFollowUpOptions: (nextOptionId: string) => void;
  currentlyRenderedOptionIds: string[];
}

const AddFollowup: FC<AddFollowupProps> = React.memo(function AddFollowupComponent({
  fieldId,
  setFollowUpOptions,
  currentlyRenderedOptionIds,
}: AddFollowupProps) {
  const { t } = useTranslation('hrFormTemplate');
  const allOptionsFromSchema = useGetItemProperty<FieldOptionT[]>(fieldId, 'optionList') || [];

  const nextAvailableOptionIdToAdd = useMemo(() => {
    const allSchemaOptionIds = allOptionsFromSchema.map((option) => option.id);
    return allSchemaOptionIds.find((id) => !currentlyRenderedOptionIds.includes(id));
  }, [allOptionsFromSchema, currentlyRenderedOptionIds]);

  const handleAddFollowUp = useCallback(() => {
    if (allOptionsFromSchema.length === 0) return;

    if (nextAvailableOptionIdToAdd) {
      setFollowUpOptions(nextAvailableOptionIdToAdd);
    } else {
      console.warn('AddFollowup: No available options left to add a new follow-up rule UI for.');
    }
  }, [allOptionsFromSchema.length, nextAvailableOptionIdToAdd, setFollowUpOptions]);

  if (allOptionsFromSchema.length === 0 || !nextAvailableOptionIdToAdd) {
    return null;
  }

  return (
    <Button variant="link" fontSize="xs" fontWeight="normal" onClick={handleAddFollowUp} colorScheme="blue">
      {t('formBuilder.addFollowUp') || '+ Add Follow-up Rule'}
    </Button>
  );
});

export default AddFollowup;
